<template>
  <fin-dialog ref="dialog"
              v-model="dialog"
              :max-width="450"
              content-class="fin-selector-dialog"
              persistent
              @input="(val) => {if (val === false){closeTool()}}"
  >
    <template #title>{{ title }}</template>
    <template #actions>
      <v-btn outlined tile large
             @click="closeTool"
             class="mr-6 mb-2 px-5 cancelBtn">
        Abbrechen
      </v-btn>
      <v-btn dark tile large @click="selectItem"
             :disabled="!isFormValid"
             class="mx-0 mb-2 px-5 submitBtn">
        {{ okButtonLabel }}
      </v-btn>
    </template>
    <fin-data-loader :resolver="options" class="loader">
      <template #content="{data}">
        <div class="fin-selector-dialog-content">
          <p class="font-weight-bold select-box-title pt-6 mb-1" style="font-size: 16px" v-if="selectBoxTitle">
            {{ selectBoxTitle }}
          </p>
          <fin-select-box :class="!selectBoxTitle ? 'mb-10 mt-3' : 'mb-10'"
                          style="background-color: white"
                          :items="data"
                          :label="selectorLabelHint"
                          v-model="selectedItem"
                          :selectBoxItemTitle="selectBoxItemTitle"
                          :selectBoxItemValue="selectBoxItemValue"
                          @input="(val) => { openNewList(newListLabel && val === newListLabel)}"
                          :new-list="newListCreationEnabled"
                          :newListLabel="newListLabel"
          >
            <template #icon v-if="!checkIfNewItemCreationAllowed()">
              <fin-subscription-lock color="fin-color-primary-dark"/>
            </template>
          </fin-select-box>

          <div v-if="newList" class="pb-5">
            <h2 class="font-weight-bold pl-1 pb-2" style="font-size: 1.2em">{{ introTextNewList }}</h2>
            <v-text-field class="ml-2"
                          style="background-color: white;" outlined :rounded="true"
                          v-model="inputText"
                          height="48"></v-text-field>
          </div>

        </div>
      </template>
    </fin-data-loader>
  </fin-dialog>
</template>

<script>
import FinSelectBox from '@/components/common/SelectBox'
import FinDataLoader from "@/components/common/DataLoader"
import FinSubscriptionLock from "@/components/common/subscription/lock"

export default {
  //TODO this should be or use a form dialog (als see editable property)
  name: 'FinChooseSelector',
  components: {FinSubscriptionLock, FinDataLoader, FinSelectBox},
  props: {
    /** The title of the choose selector */
    title: {
      type: String,
      default: undefined,
      required: true
    },
    /** The title to display before the select box */
    selectBoxTitle: {
      type: String,
      default: undefined
    },
    /** The attribute name of the object to use as the label of the selection item */
    selectBoxItemTitle: {
      type: String,
      default: undefined,
      required: true
    },
    /** The attribute name of the object to use as the value of the selection item */
    selectBoxItemValue: {
      type: String,
      default: undefined,
      required: true
    },
    /** The text to display as a label (if no item is selected) or as a hint (if one item is selected) */
    labelHint: {
      type: String,
      default: ''
    },
    /** The array or function to get the elements for the selection */
    options: {
      type: [Array, Function],
      default: undefined,
      required: true
    },
    /** Sets the pre-elected item */
    preSelectedItem: {
      type: Object,
      default: undefined
    },
    /** The dialog value */
    value: {
      type: Boolean,
      default: true
    },
    /** The label for the ok button */
    okButtonLabel: {
      type: String,
      default: "Speichern"
    },
    /** Enables the creation of a new list item */
    newListCreationEnabled: {
      type: Boolean,
      default: false
    },
    /** Sets the label for the + button */
    newListLabel: {
      type: String,
      default: undefined
    },
    /** A description text to be shown if clicked on + button */
    introTextNewList: {
      type: String,
      default: undefined
    },
    /** Function to check if the creation of a new item is allowed */
    checkIfNewItemCreationAllowed: {
      type: Function,
      default: () => {
        return true
      }
    },
    /** Function to be called if the creation of a new item is not allowed */
    newItemCreationNotAllowedAction: {
      type: Function,
      default: () => {
        return true
      }
    }
  },
  data() {
    return {
      newList: false,
      selectedItem: this.preSelectedItem,
      inputText: null,
      selectorLabelHint: this.labelHint
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(newValue) {
        /**
         * Emits the new dialog value if closed.
         */
        this.$emit('input', newValue)
      }
    },
    isNewListValid() {
      return !this.newList || (this.inputText && this.inputText.trim())
    },
    isFormValid() {
      return this.selectedItem && this.isNewListValid
    }
  },
  methods: {
    openTool() {
      this.dialog = true
    },
    closeTool() {
      this.dialog = false
      this.newList = false
      this.selectedItem = this.preSelectedItem
      this.selectorLabelHint = this.labelHint

      /**
       * Emitted if new item should be created.
       * @event closeChooseSelector
       * @type {String} the string of the new item
       */
      this.$emit('closeChooseSelector')
    },
    openNewList(open) {
      const checkIfNewItemCreationAllowed = open ? this.checkIfNewItemCreationAllowed() : true
      if (checkIfNewItemCreationAllowed) {
        this.newList = open
        this.selectorLabelHint = open ? this.newListLabel : this.labelHint
      } else {
        this.newItemCreationNotAllowedAction()
      }
    },
    selectItem() {
      if (this.newList) {
        /**
         * Emitted if new item should be created.
         * @event createNewItem
         * @type {String} the string of the new item
         */
        this.$emit('createNewItem', this.inputText)
      } else {
        /**
         * Emitted if an item has been selected.
         * @event submitSelectedItem
         * @type {String} the string of the selected item
         */
        this.$emit('submitSelectedItem', this.selectedItem)
      }
      this.closeTool()
    }
  },
  watch: {
    preSelectedItem(val) {
      this.selectedItem = val
    }
  }
}
</script>

<style lang="scss" scoped>
.fin-selector-dialog-content {
  padding: 52px 48px 20px;
}

.fin-icon-close {
  position: absolute;
  right: 0;
  margin: 20px;
  z-index: 30;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}

::v-deep .v-text-field--rounded > .v-input__control > .v-input__slot {
  margin: unset;
  min-height: 30px !important;
}

::v-deep .v-dialog {
  box-shadow: 4px 4px 0 0 rgba(0, 0, 0, .12) !important;
}

::v-deep .v-text-field .v-input__append-inner {
  margin-top: 15px !important;
}
</style>
